<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card :title="`Olá ${authUser.primeiroNome},`">
          <b-card-text>
            <p>
              Você está conectado com
              <b>{{ authUser.empresaRazaoSocial }}</b>
            </p>
            <b-row>
              <b-col>
                <b-button
                  v-b-toggle.troca-empresa-sidebar
                  variant="outline-primary"
                  block
                  @click="fetchTroca()"
                >
                  <feather-icon icon="RefreshCwIcon" />
                  Trocar conta
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  to="/perfil"
                  block
                >
                  <feather-icon icon="UserIcon" />
                  <span class="align-middle"> Perfil</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="checkPermission('/reservas')"
        lg="3"
        cols="6"
        md="4"
      >
        <router-link to="/reservas">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="CalendarIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Reservas
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/assembleias/votacao')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/assembleias/votacao">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="MessageSquareIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Assembleias
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/boletos')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/boletos">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="DollarSignIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Faturas
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/avisos')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/avisos">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="SquareIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Avisos
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/ocorrencias')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/ocorrencias">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="BookOpenIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Ocorrências
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/telefonesuteis">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="PhoneIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Telefones Úteis
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/correspondencias')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/correspondencias">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="PackageIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Correspondência
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/prestacaocontas')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/prestacaocontas">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="CheckSquareIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Prestação de Contas
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
      <b-col
        v-if="checkPermission('/leituras')"
        cols="6"
        md="4"
        lg="3"
      >
        <router-link to="/leituras">
          <b-card
            align="center"
            text-variant="white"
            bg-variant="primary"
            class="cursor-pointer"
          >
            <b-card-text>
              <feather-icon
                icon="ActivityIcon"
                size="40"
              />
            </b-card-text>
            <b-card-text class="text-truncate">
              Consumo
            </b-card-text>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    <troca-empresa-sidebar />
  </div>
</template>

<script>
import { VBToggle } from 'bootstrap-vue'
import Permissions from '../auth/permissions.json'
import TrocaEmpresaSidebar from './commons/TrocaEmpresaSidebar.vue'

export default {
  components: {
    TrocaEmpresaSidebar,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  computed: {
    authUser() {
      const user = this.$store.getters['auth/authUser']()
      return user
    },
  },
  methods: {
    fetchTroca() {
      this.$store.dispatch('conta/clearMinhasEmpresas')
      this.$store.dispatch('conta/fetchMinhasEmpresas')
    },
    checkPermission(path) {
      return Permissions[`${process.env.VUE_APP_CODE}`][path]
    },
  },
}
</script>

<style>
.avoid-break-word {
  word-break: initial;
}
</style>
